import gql from "graphql-tag";
import { contactDetailsFields } from "../queries/getContactDetails";

export const CREATE_LEAD = gql`mutation privateCreateLead($createLeadInput: CreateLeadInput!) {
    privateCreateLead(createLeadInput: $createLeadInput) {
        ${contactDetailsFields}
    }
}`;
